module.exports = __webpack_public_path__ + "static/media/04_profile_with_loops.c96515ca.png";